@if (value.attachments?.size > 0) {
<div class="attachments">
  <div class="label">{{ this.title }} {{ value.attachments.size }}/5</div>
  <div class="line"></div>
</div>
}

<div class="attachments-container">
  @for (attachment of value.attachments | keyvalue; track attachment) {
  <div class="ui label">
    <span (click)="onClickAttachment(attachment.value)">{{
      attachment.key
    }}</span>
    <i
      (click)="removeAttachment(attachment.key, comment)"
      class="close icon"
    ></i>
  </div>
  }
</div>

<div
  class="textarea-drop-wrapper"
  [class.drag-over]="isDragOver"
  (dragenter)="onDragEnter($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <textarea
    [value]="value.message"
    (input)="onInput($event)"
    (paste)="onPaste($event)"
    (blur)="onTouched()"
    [placeholder]="placeholder"
    [attr.disabled]="disableComponent"
  ></textarea>
</div>
